import i18n from '../i18n';
import { useToast } from '../store/toast';
import { haptic } from '../hooks/useTelegram';

/** Copy text to the clipboard reliably (Telegram WebView often blocks the async
 *  Clipboard API, so fall back to a hidden textarea + execCommand), then show a
 *  toast. Wire every copy button in the app through this. */
export async function copyText(text: string): Promise<void> {
  const ok = await writeClipboard(text);
  haptic();
  useToast.getState().show(i18n.t(ok ? 'common.copied' : 'common.copyFailed'));
}

async function writeClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through to the legacy path */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.readOnly = true;
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
